export default __webpack_public_path__ + "static/media/cancel-6760a41dade45c51dfb6cfc31a47bed7.png";